import React from "react";
import { useHistory } from "react-router-dom";

import { GET_APP_INFO_AND_ACCOUNTS } from "../../../api/gql";

import { URI_PATHS } from "../../../constants";

import ContinueButton from "../common/ContinueButton";
import LinkBankForm from "../linkBank/LinkBankForm";
import withQuery from "../wrappers/gql/withQuery";

const MockDashboardForm = ({ setErrorNetwork, data: linkBankInfo }) => {
  const history = useHistory();
  const { meetsBalanceThreshold } = linkBankInfo.getBankAccounts;

  return (

    <div className="flex justify-between">
      <div className="flex items-center justify-center w-1/2 mr-1">
        <LinkBankForm setErrorNetwork={setErrorNetwork} />
      </div>
      <ContinueButton
        className="btn btn-green text-white w-1/2 ml-1"
        buttonText="Unlock Card"
        disabled={!meetsBalanceThreshold}
        onClick={() => history.push(URI_PATHS.DECISION)}
      />
    </div>
  );
};

export default withQuery(GET_APP_INFO_AND_ACCOUNTS)(MockDashboardForm);